export default {
  BASIC: 'BASIC',
  MEDIUM: 'MEDIUM',
  HIGHER: 'HIGHER',
  POSTGRADUATE: 'POSTGRADUATE',
}
